export default __webpack_public_path__ + "static/media/880.02ad61f8.png";